import { render } from "./FoodMenuEditContainer.vue?vue&type=template&id=45069d46&scoped=true&ts=true"
import script from "./FoodMenuEditContainer.vue?vue&type=script&lang=ts"
export * from "./FoodMenuEditContainer.vue?vue&type=script&lang=ts"

import "./FoodMenuEditContainer.vue?vue&type=style&index=0&id=45069d46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45069d46"]])

export default __exports__